import { useEffect } from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom'
import Home from '../src/pages/Home'
import NoPage from '../src/pages//NoPage'

function SkyraReloader() {
  const location = useLocation()

  useEffect(() => {
    window.skyra?.reload?.()
  }, [location.pathname])

  return null
}

const App = () => (
  <Router>
    <SkyraReloader />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="*" element={<NoPage />} />
    </Routes>
  </Router>
)

export default App
